import { FC, useCallback, useMemo } from "react";
import { Button, DialogActions } from "@mui/material";
import { CsvSelectedPossibleColumns } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/csv-v2/dialog/utils/types";
import { useAppDispatch } from "@/store/hooks";
import { resourceExplorerCSVDataLinkFetcherThunk } from "@/store/resource-explorer/thunks/widgets/csv/resourceExplorerCSVDataLinkFetcherThunk";

interface CsvDownloadDialogActionsProps {
  name: string;
  selectedColumnKeys: CsvSelectedPossibleColumns | null;
  onClose(): void;
  tagKeys: string[];
  dimensions: string[];
}

export const CsvDownloadDialogActions: FC<CsvDownloadDialogActionsProps> = ({
  name,
  selectedColumnKeys,
  onClose,
  tagKeys,
  dimensions,
}) => {
  const dispatch = useAppDispatch();

  const exportClickHandler = useCallback(() => {
    const keys = Object.keys(selectedColumnKeys ?? {});
    const checkedColumns = keys.reduce((result, item) => {
      if (selectedColumnKeys?.[item]) {
        result.push(item);
      }
      return result;
    }, [] as string[]);
    dispatch(
      resourceExplorerCSVDataLinkFetcherThunk({
        csvColumns: checkedColumns ?? [],
        fileName: name,
        tagKeys,
        dimensions,
      }),
    );
    onClose();
  }, [dispatch, name, selectedColumnKeys, onClose, tagKeys, dimensions]);

  const selectedColumnLength = useMemo(() => {
    return Object.values(selectedColumnKeys ?? {}).filter((value) => value)
      .length;
  }, [selectedColumnKeys]);

  return (
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button
        variant="contained"
        onClick={exportClickHandler}
        disabled={!name || selectedColumnLength < 1}
      >
        Export
      </Button>
    </DialogActions>
  );
};
